module.exports = __webpack_public_path__ + "static/images/styles/images/icons/fort-battle.dbe41ba0.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/icons/fort-battle.png
// module id = 3633
// module chunks = 11